<style scoped>
.number-input {
  width: 15px;
  border: 0px;
  border-bottom: 0.5px solid;
  text-align: center;
}
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
}

input[type=number] {
    -moz-appearance:textfield; /* Firefox */
}
</style>

<template>
  <div class="display-flex">
    <input :value="minute" type="number" class="number-input" min="0" max="59" @change="onChangeMinute"/>:
    <input :value="second" type="number" class="number-input" min="0" max="59" @change="onChangeSecond"/>
  </div>
</template>

<script>
export default {
  name: 'TimestampInput',
  props: {
    value: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      minute: this.addLeadingZero(Math.floor(this.value / 60).toString()),
      second: this.addLeadingZero((this.value % 60).toString()),
      data: this.value,
    }
  },
  watch: {
    data(newValue) {
      this.$emit('input', newValue);
    }
  },
  computed: {
    
  },
  mounted() {
    
  },
  methods: {
    onChangeMinute(e) {
      this.minute = this.addLeadingZero(e.target.value);
      this.data = parseInt(this.minute) * 60 + parseInt(this.second);
    },
    onChangeSecond(e) {
      this.second = this.addLeadingZero(e.target.value);
      this.data = parseInt(this.minute) * 60 + parseInt(this.second);
    },
    
    addLeadingZero(value) {
      return value.length < 2 ? "0" + value : value;
    },
  },
}

</script>
